<div class="notification_container">
    <div class='notification-content' *ngFor="let values of state | paginate: { itemsPerPage: 7,currentPage: currentPage,totalItems: totalItems } , let i=index" tabindex="0" >
        <div class="content-icon">
            <div [ngClass]="values.status.toLocaleLowerCase() ==='read'? 'greenIcon' : 'place-holder'"><img  tabindex="0" src={{isNewIcon}} alt="isNewIcon" *ngIf="values.status.toLocaleLowerCase() ==='read'"></div>
            <div  [ngClass]="values.notificationType === 'offer'? 'notificationIconOffer' : 'hiddenClass'" ><img tabindex="0" src={{notificationIcon}} alt="notificationIcon" *ngIf="values.notificationType === 'offer'"></div>
            <div [ngClass]="values.notificationType === 'update'? 'notificationIcon' : 'hiddenClass'"><img  tabindex="0" src={{activeIcon}} alt="activeIcon" *ngIf="values.notificationType ==='update'"></div>
            <div [ngClass]="values.notificationType === 'action'? 'notificationIconOffer' : 'hiddenClass'"><img tabindex="0" class="notificationIcon" src={{actionIcon}} alt="mactionIcon" *ngIf="values.notificationType === 'action'"></div>

            <div class="content-description">
                <div class="description">
                    <a class="title-link" *ngIf="values.notificationLink !== ''" (click)="navigation(i)" tabindex="0" >{{values.notificationType.charAt(0).toUpperCase() + values.notificationType.slice(1)}}: {{values.notificationTitle}}</a>
                    <p class="title" *ngIf="values.notificationLink === ''" tabindex="0" >{{values.notificationType.charAt(0).toUpperCase() + values.notificationType.slice(1)}}: {{values.notificationTitle}}</p>
                    <p tabindex="0" *ngIf="!values.hasReport ; else downloadable">{{values.notificationDescription}}</p>
                    <ng-template #downloadable>
                        <p tabindex="0"> <span class="content-link" (click)="downloadReport(values.requestId)">{{ notificationService.state.clickHere }}</span> {{values.notificationDescription}} </p>
                    </ng-template>
                </div>
                <div class="close">
                    <button aria-label="Delete" (click) = "deleteNotification(values.id)">
                        <img class="closeIcon" src="{{closeIcon}}" alt="">
                        <span class="deleteNotification">Delete</span>
                    </button>
                    <div class="date" tabindex="0" >{{values.dateCreated}}</div>
                </div>
            </div>
        </div>
        <hr class="content" />
    </div>
 
    

</div>